/**
 * @generated SignedSource<<8565fe16a497d02fd747aeadbc302819>>
 * @relayHash aea270e226d8a36fca463d7affb2f210
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1797655a1c1fa79b9816e81af5f46d427ab89c8d6472b21d338839898a57f1d0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isValidationFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-improve-validation.relayprovider';
import isConditionsFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-parent-trigger-conditions.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1797655a1c1fa79b9816e81af5f46d427ab89c8d6472b21d338839898a57f1d0",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": isValidationFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmjourneybuilderconditionsmartvaluerelayprovider": isConditionsFGEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderparenttriggerconditionsrelayprovider": isConditionsFGEnabled_provider
    }
  }
};

export default node;
